import {BaseService} from "./BaseService";
import {ApiResponse} from "../../shared/models/ApiResponse";

export class AccountService extends BaseService {

    /**
     * check invest account exists.
     * @param email
     */
    async checkAccountExist(email: string) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/kundenportal/v1/invest/check-account', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    email: email
                })
            })
                .then(res => this.factoryApiResponse(res)).then((apiResponse: ApiResponse) => {
                if (apiResponse.success) {
                    resolve(apiResponse);
                } else {
                    reject(apiResponse);
                }
            })
                .catch(reason => {
                    reject(reason);
                });
        });
    }

    /**
     * request mail for login.
     * @param email
     * @param password
     * @param redirectUrl
     */
    async requestLogin(email: string, password?: string, redirectUrl?: string): Promise<ApiResponse> {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/kundenportal/v1/account/request-login', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    email: email,
                    password: password,
                    redirect: redirectUrl,
                })
            })
                .then(res => this.factoryApiResponse(res)).then((resp: ApiResponse) => {
                if (resp.success) {
                    resolve(resp);
                } else {
                    reject(resp);
                }
            })
                .catch(reject);
        });
    }

    /**
     * request mail to create an account.
     * @param email
     * @param termsOfUseAccepted
     * @param newsletterCustomerPortal
     * @param redirectUrl
     * @param agId
     */
    async requestCreateAccount(email: string, termsOfUseAccepted: boolean, newsletterCustomerPortal: boolean, redirectUrl?: string, agId?: string): Promise<ApiResponse> {
        const affiliateCode = this.dataStore.retrieveData('affiliateCode');
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/kundenportal/v1/account/request-create', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    email: email,
                    redirect: redirectUrl,
                    termsOfUseAccepted: termsOfUseAccepted,
                    newsletterCustomerPortal: newsletterCustomerPortal,
                    affiliateCode: affiliateCode,
                    agId: agId
                })
            }).then(res => this.factoryApiResponse(res)).then(json => {
                if (json.success) {
                    resolve(json);
                } else {
                    reject(json);
                }
            }).catch(reject);
        });
    }

    /**
     * check is the user logged in.
     */
    async isLoggedIn(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            if (this.dataStore.retrieveData('user') === null) {
                resolve(false);
                return;
            }

            if (this.isCurrentlyLoggedIn !== null) {
                resolve(this.isCurrentlyLoggedIn);
                return;
            }

            fetch('/wp-json/kundenportal/v1/account/is-logged-in', {
                method: 'GET',
                headers: this.getAuthHeader(),
            })
                .then(res => this.factoryApiResponse(res)).then(response => {
                this.isCurrentlyLoggedIn = response.success;
                resolve(response.success);
            })
                .catch(reject);
        });
    }
}
